import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import AuthShell from "../components/AuthShell";
import { useAuth, formatApiError } from "../context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Compte créé ! Bienvenue.");
      nav("/mon-espace", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Inscription impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="[ Espace membre ]"
      title="Créer un compte."
      footer={<>Déjà membre ? <Link to="/connexion" className="text-ink font-semibold link-underline">Se connecter</Link></>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <div>
          <label className="label-mono text-ink/60 block mb-2">Nom complet</label>
          <input type="text" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="register-name" className="w-full bg-white border hairline rounded-sm px-4 py-3.5 outline-none focus:border-gold transition-colors" placeholder="Jean Dupont" />
        </div>
        <div>
          <label className="label-mono text-ink/60 block mb-2">Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="register-email" className="w-full bg-white border hairline rounded-sm px-4 py-3.5 outline-none focus:border-gold transition-colors" placeholder="vous@entreprise.fr" />
        </div>
        <div>
          <label className="label-mono text-ink/60 block mb-2">Mot de passe</label>
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="register-password" className="w-full bg-white border hairline rounded-sm px-4 py-3.5 outline-none focus:border-gold transition-colors" placeholder="Au moins 6 caractères" />
        </div>
        <button type="submit" disabled={loading} data-testid="register-submit"
          className="group w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold text-ink px-6 py-4 label-mono hover:bg-ink hover:text-paper transition-colors disabled:opacity-60">
          {loading ? <><Loader2 size={16} className="animate-spin" /> Création...</> : <>Créer mon compte <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></>}
        </button>
      </form>
    </AuthShell>
  );
}
